import {
	lazy,
} from 'react';

import {
	LOGIN_ROUTES,
} from '@routes/lpdipro/public/login';
import {
	PATHS,
} from '@routes/paths';
import {
	Navigate,
} from 'react-router-dom';

// LAZY LOADING
const PageAppPublic = lazy(() =>
	import('@layouts/Pages/PageAppPublic').then((module) => ({
		default: module.PageAppPublic,
	})),
);
const PageLogin = lazy(() => import('@layouts/Pages/PageLogin').then((module) => ({
	default: module.PageLogin,
})));
const PageError = lazy(() => import('@layouts/Pages/PageError').then((module) => ({
	default: module.PageError,
})));

export const PUBLIC_ROUTES = [
	{
		children: LOGIN_ROUTES,
		element: <PageLogin />,
		path: PATHS.LOGIN._ROOT,
	},
];

const PUBLIC_ROUTES_REDIRECT = [
	{
		element: <Navigate to={PATHS.LOGIN._ROOT} />,
		path: '*',
	},
	{
		element: <PageError />,
		path: PATHS.ERROR._ROOT,
	},
];

export const PUBLIC_ROUTES_GLOBAL = [
	{
		children: [
			...PUBLIC_ROUTES,
			...PUBLIC_ROUTES_REDIRECT,
		],
		element: <PageAppPublic />,
	},
];
